import { APIMethods, NutrientCategory } from "@typeDefinitions";
import { fetchData } from "@utils/api";

export async function requestNutrientCategories(): Promise<NutrientCategory[]> {
  const { data } = await fetchData(`/nutrient-categories`, APIMethods.GET);
  return data;
}
